var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 54,
    viewBox: "0 0 72 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 53,
    rx: 14.5,
    fill: "white",
    stroke: "#ABABAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.458 15C40.698 16.32 40.098 17.64 39.378 18.6C38.658 19.56 37.338 20.4 36.018 20.28C35.778 18.96 36.378 17.76 37.098 16.8C37.938 15.84 39.258 15.12 40.458 15ZM44.298 35.88C44.898 34.92 45.258 34.32 45.738 33.24C42.018 31.8 41.418 26.52 45.138 24.6C44.058 23.16 42.498 22.44 40.938 22.44C39.858 22.44 39.138 22.68 38.418 22.92C37.818 23.16 37.338 23.28 36.738 23.28C36.018 23.28 35.538 23.04 34.818 22.8C34.098 22.56 33.378 22.32 32.538 22.32C30.858 22.32 29.058 23.28 27.978 25.08C26.418 27.48 26.658 32.16 29.178 36C30.258 37.44 31.458 39 33.018 39C33.738 39 34.098 38.76 34.578 38.64C35.178 38.4 35.778 38.16 36.738 38.16C37.818 38.16 38.298 38.4 38.898 38.64C39.378 38.88 39.738 39 40.458 39C42.138 39 43.338 37.2 44.298 35.88Z",
    stroke: "#ABABAB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleButton);
export default __webpack_public_path__ + "static/media/apple-button.1d346cd2d632fb6e59d70a3874d40707.svg";
export { ForwardRef as ReactComponent };